module.exports = __webpack_public_path__ + "img/52.5.COD.dbc13d91.png";